import React, { useState, useEffect } from 'react';
import '../styles/Contact.css';
import { updatePageSEO, seoData } from '../utils/SeoUtils';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update SEO for contact page
    updatePageSEO(seoData.contact.title, seoData.contact.description, seoData.contact.keywords);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Construir mensagem do WhatsApp
    const whatsappMessage =
      `Olá! Gostaria de solicitar um orçamento:

` +
      `Nome: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Telefone: ${formData.phone}\n` +
      `Serviço: ${formData.service || 'Não especificado'}\n` +
      `Detalhes: ${formData.message}`;

    // Codificar a mensagem para URL
    const encodedMessage = encodeURIComponent(whatsappMessage);

    // Número do WhatsApp (usando a variável de ambiente)
    const phoneNumber =
      '55' + (process.env.REACT_APP_WHATSAPP_NUMBER?.replace(/[^0-9]/g, '') || '66999230430');

    // Redirecionar para WhatsApp
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');

    // Limpar formulário
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: '',
    });
  };

  return (
    <div className="contact">
      {/* <section className="contact-hero">
        <div className="container">
          <h1>Entre em Contato</h1>
          <p>Fale conosco para um orçamento gratuito do seu projeto</p>
        </div>
      </section> */}

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Fale Conosco</h2>
              <p>
                Pronto para discutir seu projeto? Entre em contato para uma consulta e orçamento
                gratuitos.
              </p>

              <div className="contact-item">
                <h4>📱 Telefone</h4>
                <p>{process.env.REACT_APP_PHONE_NUMBER}</p>
                <p>WhatsApp: {process.env.REACT_APP_WHATSAPP_NUMBER}</p>
              </div>

              <div className="contact-item">
                <h4>📍 Nosso Endereço</h4>
                <p>Av. Santos Dumont, 63 - Jardim Monte Libano</p>
                <p>Rondonópolis - MT, 78714-133</p>
              </div>

              <div className="contact-item">
                <h4>⏰ Horários</h4>
                <p>Segunda - Sexta: 07:00 - 17:00</p>
                <p>Sábado: 07:00 - 11:00</p>
                <p>
                  <strong>Atendimento Emergencial 24h Disponível</strong>
                </p>
              </div>

              {/*
              <div className="contact-item">
                <h4>📧 Email</h4>
                <p>{process.env.REACT_APP_EMAIL}</p>
                <p>{process.env.REACT_APP_EMERGENCY_EMAIL}</p>
              </div>
              */}
            </div>

            <div className="contact-form">
              <h2>Solicitar Orçamento</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nome Completo *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Número de Telefone *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="service">Serviço Necessário</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Selecione um serviço</option>
                    <option value="munck-convencional">Munck Convencional (45 ton.metro)</option>
                    <option value="munck-especial-e8">Munck Especial E8 (46 ton.metro)</option>
                    <option value="munck-especial-flyjib">
                      Munck Especial FLYJIB (62 ton.metro)
                    </option>
                    <option value="guindaste-70-toneladas">
                      Guindaste 70 Toneladas (59m lança)
                    </option>
                    <option value="guindaste-90-toneladas-zoomlion">
                      Guindaste 90 Toneladas Zoomlion (65m lança)
                    </option>
                    <option value="guindaste-90-toneladas-sany">
                      Guindaste 90 Toneladas SANY (76,5m lança)
                    </option>
                    <option value="other">Outro / Não tenho certeza</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Detalhes do Projeto *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Por favor, descreva seu projeto, localização, cronograma e quaisquer requisitos específicos..."
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="submit-button"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  Enviar Mensagem via WhatsApp
                  <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="currentColor"
                    style={{ marginLeft: '8px' }}
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="location-section">
        <div className="container">
          <h2>Como Chegar</h2>
          <p>Encontre-nos facilmente usando o mapa abaixo:</p>

          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBhcHSPiDFJLLzinTrXzjkC6U1KUssPBu4&q=Mega-Ton+Servi%C3%A7os+de+Munck,Av.+Santos+Dumont+63+Jardim+Monte+Libano+Rondonopolis+MT+78714-133"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização da MEGATON"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
